module.exports = __webpack_public_path__ + "static/media/Mili Gafni.5393bd70.png";